import { IState } from "./types";

export const UPDATE_DATA = "standing/updateStanding";
export const CLEAR_STANDING_STORE = "standing/clearStandingStore";

export const initialState: IState = {
  data: [],
};
